import React, { useEffect, useState, Fragment } from "react";
import PropTypes from "prop-types";
import fetchData from "verticales/FetchData";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import ViewGraficoProcesos from "./ViewGrafico";
import ViewGraficProcess from "./viewGraficoProcesos";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

const url = "https://5djo5qwa3l.execute-api.us-east-1.amazonaws.com/dimo-goyito/ec2/";

const ViewProcesos = ({ instanceId, timeIni, timeFin, handleCloseModal }) => {
  const [data, setData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [msgError, setMsgError] = useState({});
  const [categories, setCategories] = useState([]);
  const [series, setSeries] = useState([]);
  const [seriesRam, setSeriesRam] = useState([]);

  useEffect(() => {
    fetchDataFromApi();
  }, []);

  const fetchDataFromApi = async () => {
    const params = {
      action: "aws-agente",
      instanceId,
      timeIni: parseInt(timeIni),
      timeFin: parseInt(timeFin),
    };

    try {
      const response = await fetchData(url, "ec2-get-agente", params);
      console.log("Respuesta completa:", response);

      const data = Array.isArray(response) ? response : response.result || [];

      if (!Array.isArray(data)) {
        throw new Error("La estructura de respuesta no es un array");
      }

      const htProcesos = new Map();
      const htProcesosRam = new Map();
      let arrTime = [];

      data.forEach((objAgenteProcess, i) => {
        const arrCM = objAgenteProcess.payload["servicios-cpu"];
        arrCM.forEach((objCM) => {
          const nombre = objCM.nombre;
          const cpu = parseFloat(objCM.cpu.replace(",", "."));
          const arrData = htProcesos.get(nombre) || Array(data.length).fill(0.0);
          arrData[i] += cpu;
          htProcesos.set(nombre, arrData);
        });

        const prcRamMoment = parseFloat(objAgenteProcess.payload["ram-total"]);
        const arrMen = objAgenteProcess.payload["servicios-ram"];
        const sumRam = arrMen.reduce(
          (acc, obj) => (obj.nombre === "PercentUsedRAM" ? acc : acc + obj.ram),
          0
        );
        const undPrc = sumRam > 0 ? prcRamMoment / sumRam : 1;

        arrMen.forEach((objMen) => {
          if (objMen.nombre === "PercentUsedRAM") return;
          const nombre = objMen.nombre;
          const vlr = parseFloat((objMen.ram * undPrc).toFixed(2));
          const arrData = htProcesosRam.get(nombre) || Array(data.length).fill(0.0);
          arrData[i] += vlr;
          htProcesosRam.set(nombre, arrData);
        });

        arrTime.push(objAgenteProcess.time);
      });

      const dataSeriesCPU = Array.from(htProcesos, ([name, data]) => ({ name, data }));
      const dataSeriesRAM = Array.from(htProcesosRam, ([name, data]) => ({ name, data }));

      setSeries(dataSeriesCPU);
      setSeriesRam(dataSeriesRAM);
      setCategories(arrTime);

      setData(JSON.stringify({ dataSeriesCPU, dataSeriesRAM, arrTime }, null, 2));
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsError(true);
      setMsgError({ title: "Error Code exceptions", body: error.toString() });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Grid item xs={4} sm={6} lg={12}>
      <Card
        sx={{
          backgroundColor: "white",
          mx: "auto",
          maxWidth: "100%",
          maxHeight: "max-content",
          margin: 1,
          padding: 2,
          overflow: "auto",
          border: "1px solid #dfdfdf",
        }}
      >
        <Fragment>
          {isLoading ? (
            <MDBox p={3}>Generando gráfico, por favor espera...</MDBox>
          ) : isError ? (
            <MDBox p={3}>
              <MDTypography color="error" variant="h6">
                {msgError.title}
              </MDTypography>
              <MDTypography>{msgError.body}</MDTypography>
            </MDBox>
          ) : (
            <MDBox p={3}>
              <Stack direction="row" spacing={1} justifyContent="space-between">
                <MDTypography variant="h6" fontWeight="bold">
                  Informe Procesos
                </MDTypography>
                <MDButton onClick={handleCloseModal} variant="outlined" color="info">
                  Cerrar
                </MDButton>
              </Stack>

              {/* <MDBox mt={2}>
                <textarea value={data} readOnly style={{ width: "100%", height: "150px" }} />
              </MDBox> */}

              <MDBox mt={4}>
                <ViewGraficProcess categories={categories} series={series} seriesRam={seriesRam} />
              </MDBox>
            </MDBox>
          )}
        </Fragment>
      </Card>
    </Grid>
  );
};

ViewProcesos.propTypes = {
  instanceId: PropTypes.string.isRequired,
  timeIni: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  timeFin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  handleCloseModal: PropTypes.func.isRequired,
};

export default ViewProcesos;
